<template>
  <BlokkliProvider v-if="node" v-bind="node.blokkliProps">
    <div class="page">
      <section class="section has-background-yellow-light">
        <div class="container">
          <h2 class="title is-h1 is-page-title">{{ node.title }}</h2>
          <div class="columns">
            <div class="column is-one-quarter">
              <menu-sidebar v-if="mainMenu" :menu="mainMenu" />
            </div>
            <div class="column">
              <views-article-taxonomy-list />
            </div>
          </div>
        </div>
      </section>

      <BlokkliField
        :list="node.paragraphs"
        name="field_content"
        class="elements"
      />
    </div>
  </BlokkliProvider>
</template>

<script lang="ts" setup>
import type { NodePageFragment } from '#graphql-operations'

defineOptions({
  name: 'MagazineOverview',
})

definePageMeta({
  name: 'magazine-overview',
  languageMapping: {
    de: '/magazin',
    fr: '/fr/magazine',
    it: '/it/magazin',
    en: '/en/magazine',
  },
})

const initData = await useInitData()
const mainMenu = initData.value.mainMenuLinks

const nuxtRoute = useRoute()

// Get the data.
const { data: query } = await useAsyncData(nuxtRoute.path, async () => {
  return await useGraphqlQuery('route', {
    path: nuxtRoute.path,
  }).then((v) => {
    return v.data
  })
})

// Handles redirects and metatags.
const { entity: node } = await useDrupalRoute<NodePageFragment>(query.value)

setBreadcrumbLinksFromRoute(query.value)
setLanguageLinksFromRoute(query.value)
await renderPageDependencies()
</script>
